import { render } from "./Customizer.vue?vue&type=template&id=538b7860&scoped=true"
import script from "./Customizer.vue?vue&type=script&lang=js"
export * from "./Customizer.vue?vue&type=script&lang=js"

import "./Customizer.vue?vue&type=style&index=0&id=538b7860&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538b7860"]])

export default __exports__